import React from 'react';

import { Typography } from '@material-ui/core';

import { Team } from '@vyce/core/src/types';

import useStyles from '../../styles';
import { TargetCheckboxGrid } from './TargetCheckboxGrid';

interface Props {
  teams: Team[];
  selectedIds: string[];
  onToggle: (id: string, checked: boolean) => void;
  onToggleAll: (checked: boolean) => void;
}

export const TeamsTargetSection: React.FC<Props> = ({ teams, selectedIds, onToggle, onToggleAll }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.detailsTitle}>Which teams?</Typography>
      <TargetCheckboxGrid
        items={teams.map(team => ({ id: team.uuid, name: team.name }))}
        selectedIds={selectedIds}
        onToggle={onToggle}
        allLabel="All teams"
        onToggleAll={onToggleAll}
      />
    </>
  );
};
